"use client";
import { Button, Result } from "antd";
import { useRouter } from "next/navigation";
import styles from "./style.module.scss";

const NotFoundPage = () => {
  const router = useRouter();
  return (
    <div className={styles.alignCenter}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => router.back()}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
